import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Used for the segment library page (partner-scoped)
export const marketingToolingSegmentLibraryAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.MarketingToolingViewAccess],
  featureToggles: [FeatureToggle.segmentLibraryEnabled],
}
